module.exports = __webpack_public_path__ + "static/media/icon.89ffb736.svg";